import React from 'react'
import { useNavigate } from 'react-router-dom';
import './component.css';
import { Navbar, Nav, Row, Col } from "react-bootstrap";
import logo from '../Assets/Logo1.svg';

interface menuBar {
  title1: string;
  title2: string;
  toggleNav: boolean;

}

export default function NavigationBar({ title1, title2, toggleNav }: menuBar | any) {

  const navigate = useNavigate();

  return (
    <Row className="justify-content-center hiddenOverflow nav-component-bg">
      <Col xs={12} md={10} lg={9} >
        <Navbar bg="" expand="lg">
          <Navbar.Brand >
            <img alt="On The Right Track Logo" src={logo} />
          </Navbar.Brand>
          {
            toggleNav ?
              <>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end mx-2">
                  <Nav className="">
                    <span onClick={() => navigate('/main')}>{title1}</span>
                  </Nav>
                  <Nav className="m-2">
                    <span onClick={() => navigate('/sponsor')}>{title2}</span>
                  </Nav>
                </Navbar.Collapse>
              </>
              : null
          }
        </Navbar>
      </Col>
    </Row>
  )
}
